export default __webpack_public_path__ + "static/media/character.eacbf57c.png";